export const ADDRESS = {
  postal_code: '',
  address: '',
  number: '',
  district: '',
  city: {
    name: '',
  },
  state: {
    name: '',
  },
  complement: '',
}
